import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import React, { type VFC, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { dispatchAddCardCommunication } from 'reactApp/hooks/subscriptionCommunication';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { sendDwh } from 'reactApp/utils/ga';

import styles from '../../SubscriptionModal.css';

const ANALYTICS_NAME = 'mnz_unbind_card_subscriptions_warning';

const sendDwhEvent = (action: 'show' | 'click') => {
    sendDwh({
        eventCategory: 'banner',
        action,
        dwh_enabled: true,
        dwhData: {
            name: ANALYTICS_NAME,
            platform: IS_PHONE_BROWSER ? 'touch' : 'web',
            ...(action === 'click' ? { button_name: 'add_card' } : {}),
        },
    });
};

type Props = {
    subscription: BillingDataSubscriptionInfo;
    onClose?: () => void;
};

export const UnbindCardWarning: VFC<Props> = ({ subscription, onClose }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        sendDwhEvent('show');
    }, []);

    const handleAddCard = useCallback(() => {
        sendDwhEvent('click');
        onClose?.();
        dispatchAddCardCommunication(dispatch, subscription);
    }, [dispatch, subscription, onClose]);

    return (
        <div className={styles.autoRenewalWarning}>
            <Icon20InfoCircleOutline className={styles.autoRenewalWarningIcon} />
            <div className={styles.autoRenewalWarningContent}>
                <span>
                    Привяжите карту, чтобы подписка продлилась.
                    <br />
                    Без неё файлам может не хватить места. Если так случится, в Почте и Облаке появятся ограничения
                </span>
                <Button
                    theme="octavius"
                    sizeMode={ButtonSizeMode.small}
                    className={styles.autoRenewalWarningButton}
                    onClick={handleAddCard}
                >
                    Добавить карту
                </Button>
            </div>
        </div>
    );
};
